import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DetalhesCircuitoRQ } from 'src/app/model/turismo/circuito.model';
import { CircuitoService } from 'src/app/services';

@Component({
  selector: 'app-circuito-detalhes',
  standalone: false,
  templateUrl: './circuito-detalhes.component.html',
  styleUrl: './circuito-detalhes.component.scss'
})
export class CircuitoDetalhesComponent implements OnInit {
  @Input() Circuito: any;
  @Input() AgenciaId: any;

  Detalhes: any;
  Servicos: string[] = [];

  carregando = false;
  mensagemErro = '';

  constructor(
    private circuitoService: CircuitoService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.buscarDetalhes();
  }

  abrirDetalhes() {
    // this.accordion.openAll();
  }
  fecharDetalhes() {
    // this.accordion.closeAll();
  }

  buscarDetalhes() {
    delete this.mensagemErro;

    let detalhesCircuitoRQ: DetalhesCircuitoRQ = new DetalhesCircuitoRQ();
    detalhesCircuitoRQ.Circuito = this.Circuito;
    detalhesCircuitoRQ.AgenciaId = this.AgenciaId;
    detalhesCircuitoRQ.DetalhesReserva = true;

    this.circuitoService.detalhesCircuitos(detalhesCircuitoRQ).subscribe(
      dados => {
        this.Detalhes = dados.Circuito.Detalhes;
      },
      (erros) => {
        this.mensagemErro = this.errorHandler(erros, "Buscar Detalhes");
        setTimeout(x => this.fecharModal(), 2500);
      });
  }

  fecharModal() {
    this.modalService.dismissAll();
  }

  public errorHandler(erro, acao: string = null): string {
    let mensagem = 'Erro';
    if (acao !== null) {
      mensagem += ' ao tentar ' + acao + ': ';
    }
    switch (erro.status) {
      case 0: mensagem += 'o servidor não respondeu, tente novamente mais tarde!'; break;
      case 401: mensagem += 'você não tem autorização para executar esta ação!'; break;
      case 404: mensagem += erro.error.mensagem; break;
      case 406: mensagem += 'a requisição não foi aceita, tente novamente!'; break;
      case 500: mensagem += 'Houve um erro interno no servidor! tente novamente, caso o erro persista, entre em contato com o suporte'; break;
      default: mensagem += erro.statusText;
    }
    return mensagem + '/' + erro.error.mensagens.join(',');
  }
}
